import axios from 'axios'

axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.timeout = 15000  // 15 second timeout for external Canvas API calls

export {
  // Direct Join (Flow 1)
  sendCode,
  verifyCode,

  // Direct Join + LTI 1.1 (Flows 1 & 2)
  getLtiCourse,
  getEnrollment,
  verifyCoupon,
  autoEnroll,
  processEnrollment,

  // LTI 1.3 (Flow 3)
  checkAccess,
  getMembership,
  verifyAccessCode,
  autoEnrollMembership,

  // LTI Tools
  searchSigns
}

const API_URL = process.env.VUE_APP_API_URL

async function verifyCoupon (enroll_token, coupon_code) {
  const url = `${API_URL}/api/lti/verify_coupon_code`
  const response = await axios.post(url, {
    enroll_token: enroll_token,
    coupon_code: coupon_code
  })
  return response.data
}

async function autoEnroll (enroll_token) {
  const url = `${API_URL}/api/lti/auto_enroll`
  const response = await axios.post(url, {
    enroll_token: enroll_token
  })
  return response.data
}

async function getEnrollment (enroll_token) {
  const url = `${API_URL}/api/lti/get_enrollment`
  const response = await axios.post(url, {
    enroll_token: enroll_token
  })
  return response.data
}

async function checkAccess (app, token, state) {
  const url = `${API_URL}/lti/check_access?app=${app}&token=${token}&state=${state}`
  const response = await axios.get(url, {withCredentials: true})
  return response.data
}

async function getMembership (token) {
  const url = `${API_URL}/lti/get_membership?token=${token}`
  const response = await axios.get(url)
  return response.data
}

async function verifyAccessCode (token, access_code) {
  const url = `${API_URL}/lti/verify_access_code`
  const response = await axios.post(url, {
    token: token,
    access_code: access_code
  })
  return response.data
}

async function autoEnrollMembership (token) {
  const url = `${API_URL}/lti/auto_enroll`
  const response = await axios.post(url, { token: token })
  return response.data
}

async function searchSigns (term) {
  let url = `${API_URL}/lti/search_signs?term=` + term
  return await axios.get(url)
}

async function processEnrollment (token, name = null, password = null) {
  const url = `${API_URL}/api/lti/process_enrollment`
  const response = await axios.post(url, {
    token: token,
    name: name,
    password: password
  })
  return response.data
}

async function sendCode (context_id, email, recaptcha_response) {
  const url = `${API_URL}/api/lti/send_code`
  const response = await axios.post(url, {
    context_id: context_id,
    email: email,
    recaptcha_response: recaptcha_response
  })
  return response.data
}

async function verifyCode (context_id, email, magic_code) {
  const url = `${API_URL}/api/lti/verify_code`
  const response = await axios.post(url, {
    context_id: context_id,
    email: email,
    magic_code: magic_code
  })
  return response.data
}

async function getLtiCourse (context_id) {
  const url = `${API_URL}/api/lti/get_course`
  const response = await axios.post(url, { context_id })  // Public endpoint, no auth needed
  return response.data.lti_course
}
